import React, { useState, useEffect } from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import PropTypes from 'prop-types';
// 日期美化
// import { dateFormat } from '../../utils/utils';
// 图片处理
import { getThumbnail } from '@src/common/utils';
import { formatImage } from '@src/common/formatImage';
// 分页组件（Swiper）
import Swiper, { Navigation, Pagination } from 'swiper';
Swiper.use([Navigation, Pagination]);

const Content = ({ content }) => {

    // const { title, thumbnails } = content[0];
    // const { data, title } = content;
    // const { name } = title;

    const [currentPage, setCurrentDPage] = useState(0);

    useEffect(() => {
        new Swiper('#swiper3', {
            autoplay: true,
            navigation: {
                prevEl: '#prev3',
                nextEl: '#next3'
            },
            pagination: {
                el: '#pagination3',
                type: 'fraction'
            },
            on: {
                slideChangeTransitionStart(e) {
                    const index = e.activeIndex;

                    setCurrentDPage(index);
                }
              }
        });
 
    }, []);

return (
<div className={styles.content}>
                <div className={styles.slide}>

                    <div className={styles.leftPart}>
                        <div className={styles.swiper3}>
                            <div className="swiper" id="swiper3">
                                <div className="swiper-wrapper">
                                    {
                                        content.map((item, index) => {
                                            
                                            return (
                                                <div className="swiper-slide" key={index}>
                                                    <div className={styles.swiperItem}>
                                                        <div className={styles.leftDescribe}>
                                                            <div className={styles.leftTitle}>
                                                                <a href={item.url} target="_blank" rel="noreferrer">
                                                                    {item.title}
                                                                </a>
                                                            </div>
                                                            <div className={styles.leftContent}>
                                                                <a href={item.url} target="_blank" rel="noreferrer">
                                                                    {item.summary}
                                                                </a>
                                                    
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })
                                    }
                                </div>
                            </div>
                        </div>

                        <div className={styles.page}>
                            <div className={styles.prev3} id="prev3" />
                            <div className="swiper-pagination3" id="pagination3" />
                            <div className={styles.next3} id="next3" />
                        </div>
                        
                    </div>
                                     
                    <div className={styles.rightPart}>
                        <div className={styles.imgWrap}>
                          
                            <a href={content[currentPage].url} target="_blank" rel="noreferrer" >
                            <img className={styles.swiperImage} src={formatImage(getThumbnail(content[currentPage]))} /> 
                            </a> 
                        </div>
                    </div>
                </div>
            </div>

    );
};

Content.propTypes = {
    content: PropTypes.object,
};
export default errorBoundary(Content);
